import { SecurityOwnershipsGroupedByOwnedId } from "features/entities/EntityCreatePage/EntityGraph/entityGraphTypes";
import { Entity } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import values from "lodash-es/values";

export const findInvestorGroup = (
  securityId: string,
  securitiesGroupedByInvestingInto: SecurityOwnershipsGroupedByOwnedId,
) => {
  const investorGroups = values(securitiesGroupedByInvestingInto);
  const group = investorGroups.find((group) =>
    group.groupOfSecurityIds.has(securityId),
  );
  return group!.investorsGroupId;
};

export const getOwningId = (
  security: {
    owning_entity_id: string;
    owned_entity_id: string;
    security_ownership_id: string;
  },
  securitiesGroupedByInvestingInto: SecurityOwnershipsGroupedByOwnedId,
  entityMap: Record<string, Entity>,
) => {
  const isInvestor =
    entityMap[security.owning_entity_id].functional_type === "investor";

  const owningId = isInvestor
    ? findInvestorGroup(
        security.security_ownership_id,
        securitiesGroupedByInvestingInto,
      )
    : security.owning_entity_id;

  return owningId;
};

export const getUniqueInvestingEdgeKey = (
  security: {
    owning_entity_id: string;
    owned_entity_id: string;
    security_ownership_id: string;
  },
  securitiesGroupedByInvestingInto: SecurityOwnershipsGroupedByOwnedId,
  entityMap: Record<string, Entity>,
) => {
  const owningId = getOwningId(
    security,
    securitiesGroupedByInvestingInto,
    entityMap,
  );

  return owningId + security.owned_entity_id;
};

export const getEdgeId = (sourceId: string, targetId: string) =>
  `${sourceId}->${targetId}`;
